import { Validators } from '@angular/forms';
import { IFormKey } from 'src/app/modules/shared/models/forms';
import { ESpecificBeneficiaryType } from '../beneficiary-form-isv/beneficiary-form-isv.constants';
import { IObjectKey } from 'src/app/modules/shared/models/objects';
import { IGianosPolicyHolder, IGianosPolicyInsured, IGianosOperationInfo, IGianosDatiOperatore, IGianosEsecutoreConto, IGianosDesignazioneBeneficiari, IGianosTitolareEffettivo, IGianosPaymentMode, IGianosPrivacy, IGianosAdequateVerification, IGianosHoldersRelationship } from '../../isv.constants';
import { options_yes_no } from '../registry-recap/registry-recap.constants';
export const search_form_template = {
    type: null,
    taxCode: null
}

export const search_form_validators = {
    type: [Validators.required],
    taxCode: [Validators.required]
}

export const search_form_keys: IFormKey[] = [
    {
        id: 'type-field',
        label: 'Natura giuridica',
        controlName: 'type',
        css: 'col-4',
        type: 'SELECT',
        options: [
            {
                key: ESpecificBeneficiaryType.PERSONA_FISICA,
                value: ESpecificBeneficiaryType.PERSONA_FISICA
            },
            {
                key: ESpecificBeneficiaryType.PERSONA_GIURIDICA,
                value: ESpecificBeneficiaryType.PERSONA_GIURIDICA
            }
        ],
    },
    {
        id: 'taxCode-field',
        label: 'Codice fiscale / Partita IVA',
        controlName: 'taxCode',
        css: 'col-4',
        type: 'INPUT',
        uppercase: true
    }
];

export const contractor_keys_PF: IObjectKey[] = [
    {
        label: 'Codice fiscale',
        key: 'fiscalCode'
    },
    {
        label: 'Data di nascita',
        key: 'birthAddress.DataNascita',
        pipe: {
            key: 'date',
            value: null
        }
    },
    {
        label: 'Tipologia',
        defaultValue: ESpecificBeneficiaryType.PERSONA_FISICA,
        key: ''
    }
];

export const contractor_keys_PG: IObjectKey[] = [
    {
        label: 'Partita IVA',
        key: 'vatCode'
    },
    {
        label: 'Tipologia',
        defaultValue: ESpecificBeneficiaryType.PERSONA_GIURIDICA,
        key: ''
    }
];


export const vcont_operation_data_form_validators = {
    agencyCode: [Validators.required],
    policyNumber: [Validators.required],
    productCode: [Validators.required],
    productCategory: [Validators.required],
    reportScope: [Validators.required],
    additionalPaymentType: null,
    redeemType: null,
    liquidationType: null,
    withdrawalType: null,
    operationAmount: null,
    paymentType: [Validators.required],
    fundOriginCountry: [Validators.required],
    fundOrigin: [Validators.required],
    fundOriginNote: null,
    designedBeneficiary: [Validators.required],
    contractorNotInsured: [Validators.required]
}

export interface IIsvCessioneContraenzaRequest {
    policyNumber: string;
    contraente: IGianosPolicyHolder;
    assicurato: IGianosPolicyInsured;
    polizzaOperazione: IGianosOperationInfo;
    operatoreContraente: IGianosDatiOperatore;
    esecutoreConto?: IGianosEsecutoreConto;
    designazioneBeneficiario?: IGianosDesignazioneBeneficiari[];
    titolareEffettivi?: IGianosTitolareEffettivo[];
    holderAdequateVerification?: IGianosAdequateVerification;
    legalPersonAdequateVerification?: any;
    tutorAdequateVerification?: any;
    holdersRelationship?: IGianosHoldersRelationship;
    privacy: IGianosPrivacy;
    anagraphicType: any;
    personType: any;
    isSubjectAble: boolean;
}

export const isv_tutor_proper_verification_form_template = {
    profession: null,
    isPEP: null
};

export const isv_tutor_proper_verification_form_validators = {
    profession: [Validators.required],
    isPEP: null
};

export const legal_guardian_form_template = {
    isContractorCapable: null
};

export const legal_guardian_form_validators = {
    isContractorCapable: [Validators.required]
};

export const legal_guardian_form_keys: IFormKey[] = [
    {
        id: 'isContractorCapable-field',
        label: 'Il contraente è capace?',
        controlName: 'isContractorCapable',
        css: 'col-4',
        type: 'RADIO',
        options: options_yes_no
    }
];